var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-uploader',{attrs:{"after-read":_vm.afterRead,"max-count":_vm.maxCount,"result-type":"text"},model:{value:(_vm.images),callback:function ($$v) {_vm.images=$$v},expression:"images"}})
}
var staticRenderFns = []

export { render, staticRenderFns }